<template>
  <div class="notice-item" :class="{'notice-item_selected': selected, 'notice-item_hasLink': item.link, 'notice-item_last': isLast}" @click="navigateToNoticeDetail(item.link)">
    <h1 class="notice-title">
      <span class="notice-tag" v-if="Number(item.is_top)">置顶</span>
      <p class="notice-p" :class="Number(item.is_top)?'notice-title_hasTag':''">{{item.title}}</p>
    </h1>
    <p class="notice-time">
      {{item.publish_time | formatTime}}
      <span v-if="item.publisher">{{` ${item.publisher} 发布`}}</span>
    </p>
    <template v-if="!item.link">
      <template v-if="!isCheckedRealHeight">
        <p class="notice-introduce notice-introduce-string" v-html="item.content_filter" ref="noticeContentString"></p>
        <div class="notice-introduce" ref="noticeContentHtml">
          <markdownBeautiful :data="item.content_html" />
        </div>
      </template>
      <template v-else>
        <p class="notice-introduce notice-introduce-string" v-if="isNeedWordBtn&&isFold" v-html="item.content_filter"></p>
        <div class="notice-introduce" v-if="(isNeedWordBtn&&!isFold)||!isNeedWordBtn" ref="noticeContentHtml">
          <markdownBeautiful :data="item.content_html" />
        </div>
        <span class="notice-wordBtn notice-wordBtn_fold" v-if="isNeedWordBtn" @click="switchFold">
          <span class="notice-wordBtn-word">{{isFold?'查看全部':'收起详情'}}</span>
          <span class="iconfont icon-jiantou" :class="{'arrow-up':!isFold}"></span>
        </span>
        <div class="clear"></div>
      </template>
    </template>
    <template v-else>
      <p class="notice-introduce notice-introduce-string" v-html="item.content_filter"></p>
      <span class="notice-wordBtn notice-wordBtn_link" v-if="item.link">
        <span class="iconfont icon-lianjie-"></span>
        <span class="notice-wordBtn-word">阅读全文</span>
        <span class="iconfont icon-changjiantou3"></span>
      </span>
      <div class="clear"></div>
    </template>
  </div>
</template>
<script>
import markdownBeautiful from '@/components/markdown-beautiful'

import moment from 'moment'

export default {
  data () {
    return {
      isNeedWordBtn: false, // 是否需要查看全部的文字btn
      isFold: true, // 是否折叠
      isCheckedRealHeight: false // 是否检查过真实高度
    }
  },
  components: {
    markdownBeautiful
  },
  props: ['item', 'index', 'isLast', 'selected', 'typeMap'],
  created () {
  },
  mounted () {
    this.checkRealHeightMoreThanVisibleHeight()
  },
  methods: {
    checkRealHeightMoreThanVisibleHeight () {
      const noticeContentString = this.$refs.noticeContentString
      const noticeContentHtml = this.$refs.noticeContentHtml

      if (noticeContentString && noticeContentHtml) {
        this.isNeedWordBtn = noticeContentHtml.getBoundingClientRect().height > noticeContentString.getBoundingClientRect().height
        this.isCheckedRealHeight = true
      } else {
        this.isNeedWordBtn = false
        this.isCheckedRealHeight = true
      }
    },
    switchFold () {
      this.isFold = !this.isFold
    },
    navigateToNoticeDetail (link) {
      if (link) window.open(link)
    }
  },
  filters: {
    formatTime: function (publishTime) {
      return moment.unix(Number(publishTime)).format('YYYY-MM-DD')
    }
  }
}
</script>
<style scoped lang='scss'>
@import '../../../style/bulma/app.sass';

.notice-item {
  padding: 20px 27px;
  border-bottom: 1px solid rgba($primary3, 0.3);
  &.notice-item_last {
    border-bottom: none;
  }
  &.notice-item_selected {
    background: linear-gradient(90deg, #fcfbf8, #ffffff);
  }
  &.notice-item_hasLink {
    cursor: pointer;
  }
  &.notice-item_hasLink:hover {
    // .notice-p {
    //   color: $primary3;
    //   transition: all .3s ease;
    // }
  }
  .notice-title {
    // display: flex;
    position: relative;
    margin-bottom: 8px;
    .notice-tag {
      position: absolute;
      top: 4px;
      padding: 1px 8px 1px;
      margin-right: 0px;
      background: $primary3;
      color: #fff;
      border-radius: 2px;
      font-size: 12px;
      font-weight: 500;
    }
    .notice-p {
      line-height: 30px;
      font-size: 22px;
      font-weight: 600;
      color: rgba(74,74,74,1);
      &.notice-title_hasTag {
        text-indent: 48px;
      }
    }
  }
  .notice-time {
    color: rgba(74, 74, 74, .6);
    font-size: 14px;
    margin-bottom: 18px;
  }
  .notice-introduce {
    color: rgba(74, 74, 74, 1);
    line-height: 32px;
  }
  .notice-introduce-string {
    @include limit-line-numbers(4);
  }
  .notice-wordBtn {
    float: right;
    color: $primary3;
    font-size: 14px;
    margin-top: 8px;
    position: relative;
    cursor: pointer;
    &.notice-wordBtn_link {
      .icon-lianjie- {
        font-size: 12px;
        margin-right: 1px;
      }
      .notice-wordBtn-word {
        padding-right: 26px;
      }
      .icon-changjiantou3 {
        position: absolute;
        top: 50%;
        right: 0;
        transform: translateY(-50%);
        overflow: hidden;
        font-size: 1.1rem;
      }
    }
    &.notice-wordBtn_fold {
      transform: translateX(-4px);
      .notice-wordBtn-word {
        padding-right: 22px;
      }
      .iconfont {
        font-size: 24px;
        margin-left: 7px;
      }
      .icon-jiantou {
        position: absolute;
        top: 50%;
        right: 0;
        transform: translateY(-50%) rotateZ(90deg);
      }
      .icon-jiantou.arrow-up {
        transform: translateY(-50%) rotateZ(-90deg);
      }
    }
  }
}
.clear {
  clear: both;
}
</style>
